import React from 'react';
import { Route, Switch } from 'react-router';

import ServiceList from './ServiceList/ServiceList';

export default function Services() {
  return (
    <Switch>
      <Route path="/services" component={ServiceList} />
    </Switch>
  );
}
